import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import PropTypes from "prop-types";
import { DEFAULTS } from "./variables";
export var makePropTypesFactory = function makePropTypesFactory(makePropTypes) {
  return function (variables) {
    return makePropTypes(Object.assign({}, DEFAULTS, variables));
  };
};
export var makeValidatingTransformFactory = function makeValidatingTransformFactory(makePropTypesFunc, transformFunc) {
  return function () {
    var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS;
    var propTypes = makePropTypesFunc(variables);
    return function (props, componentName) {
      var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "prop";
      PropTypes.checkPropTypes(propTypes, props, location, componentName);
      return transformFunc(props);
    };
  };
};
export var makeRootValidatingTransformFactory = function makeRootValidatingTransformFactory() {
  for (var _len = arguments.length, mvtfs = new Array(_len), _key = 0; _key < _len; _key++) {
    mvtfs[_key] = arguments[_key];
  }

  return function (variables) {
    var vtfs = mvtfs.map(function (func) {
      return func(Object.assign({}, DEFAULTS, variables));
    });
    return function (props, componentName) {
      var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "prop";
      return vtfs.reduce(function (acc, vtf) {
        return vtf(acc, componentName, location);
      }, props);
    };
  };
};